import { biTimeRangeLabel } from '@euler/app/components/message/widgets/bi-visualization/functions/biTimeRangeLabel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiTimeRange, BiTimeRangeKind } from '@euler/model/bi/query';
import { memo } from 'react';
import { View } from 'react-native';
import { BiChip } from '../../components/ui/BiChip';
import { biSameTimeRange, kBiDateRangeOptions } from '../functions/biDateRange';
import { AbsoluteRangeFields } from '../time-range/AbsoluteRangeFields';
import { RollingRangeFields } from '../time-range/RollingRangeFields';
import { EditorSection } from './EditorSection';
import { BiEditorQuery } from './functions/biEditorState';

/**
 * The card's own time range: a preset, "最近 N …" (stays live), or named
 * dates. A dashboard date range overrides it.
 */
export const TimeRangeSection = memo(
  ({
    query,
    onChange,
  }: {
    query: BiEditorQuery;
    onChange: (next: BiEditorQuery) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const pick = (timeRange: BiTimeRange | undefined) =>
      onChange({ ...query, timeRange });
    const listed = kBiDateRangeOptions.some(option =>
      biSameTimeRange(query.timeRange, {
        kind: BiTimeRangeKind.Relative,
        preset: option.preset,
      }),
    );
    const unlistedPreset =
      query.timeRange?.kind === BiTimeRangeKind.Relative && !listed;
    return (
      <EditorSection title="时间范围" note="看板的日期筛选会覆盖它">
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: rpx(6) }}>
          <BiChip
            label="不限"
            selected={!query.timeRange}
            onPress={() => pick(undefined)}
          />
          {unlistedPreset ? (
            <BiChip
              label={biTimeRangeLabel(query.timeRange)}
              selected
              onPress={() => undefined}
            />
          ) : null}
          {kBiDateRangeOptions.map(option => {
            const range = {
              kind: BiTimeRangeKind.Relative as const,
              preset: option.preset,
            };
            return (
              <BiChip
                key={option.preset}
                label={option.label}
                selected={biSameTimeRange(query.timeRange, range)}
                onPress={() => pick(range)}
              />
            );
          })}
        </View>
        <RollingRangeFields value={query.timeRange} onPick={pick} />
        <AbsoluteRangeFields value={query.timeRange} onPick={pick} />
      </EditorSection>
    );
  },
);
